import axios from 'axios'

export default {
  state: {
    token: '',
    userData: {}
  },

  getters: {
    getUserData (state) {
      return state.userData
    },

    getToken (state) {
      return state.token
    }
  },

  mutations: {
    setSession (state, authState) {
      // TODO: ejecutar esta acción desde plugin de servicios
      axios.defaults.headers.common.Authorization = 'Bearer ' + authState.token
      state.userData = authState.userdata
      state.token = authState.token
    },

    setUserData (state, userData) {
      state.userData = userData
    },

    setToken (state, token) {
      state.token = token
    },

    unsetSession (state) {
      // TODO: ejecutar esta acción desde plugin de servicios
      axios.defaults.headers.common.Authorization = null
      state.userData = {}
      state.token = ''
    }
  }
}
